import amplitude from "externals/amplitude";
import SessionStorage from "utils/SessionStorage";

export const toggleUIVersion = (isNewVersionEnabled) => {
  try {
    SessionStorage.setItem("isNewVersionEnabled", !isNewVersionEnabled);

    const url = new URL(window.location.href);

    url.search = new URLSearchParams().toString();
    window.history.replaceState({}, document.title, url.toString());

    amplitude.logEvent("ui_version_switched", {
      isNewVersionEnabled: SessionStorage.getItem("isNewVersionEnabled"),
    });

    window.location.reload();
  } catch (error) {
    console.error(error);
  }
};
